export class AisleCategory {
  id?: number;
  name: string;
  description?: string;
  imageUrl?: string;

  constructor(name: string, id?: number, description?: string, imageUrl?: string) {
    this.name = name;
    this.id = id;
    this.description = description;
    this.imageUrl = imageUrl;
  }
}
